export const SORT_ORDERS = {
  ASC: "asc",
  DESC: "desc",
};
